import { useTranslation } from 'react-i18next';
import { GovIcon } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import type { FilterParam } from '@gov-nx/core/types';
import { Button } from '../Button/Button';

export const FilterParameterItem = ({
	label,
	value,
	onRemove,
}: FilterParam) => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<li>
			<dl className="flex items-center gap-1 h-(--height-component-s) bg-(--background-neutral-subtlest) border-[1px] border-(--border-subtle) rounded-lg">
				<dt className="pl-4">{label}:</dt>
				<dd className="font-bold">{value}</dd>
				<Button
					onClick={onRemove}
					color="primary"
					type="base"
					size="s"
					aria-label={t('akce.wcag.zrusit-tento-filtr') + ` ${label} ${value}`}>
					<GovIcon
						slot="icon-end"
						name="x-lg"
					/>
				</Button>
			</dl>
		</li>
	);
};
